module.exports = __webpack_public_path__ + "img/fineness-1@2x.be52f3e.png";